import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { CookieService } from "ngx-cookie-service";
import { tap } from "rxjs/operators";
import * as _ from "lodash";
import { AppConfig } from "../Utilities/app-config.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { ChatService, SignalRService } from './chat.service';
import { MsalService, MsalInterceptor, BroadcastService } from '@azure/msal-angular';
@Injectable({
  providedIn: "root",
})
export class CommonInterceptorService extends MsalInterceptor implements HttpInterceptor {
  tokenType = 'bearer';
  token = 'msal.idtoken';
  agentAuthorizedApiEndpoints: any;

  constructor(
    msalService: MsalService,
    msalBroadcastService: BroadcastService,
    private _cookieService: CookieService,
    private appConfig: AppConfig,
    private _toaster: ToastrService,
    private router: Router,
    private chatService: ChatService,
    private signalRService: SignalRService
  ) {
    super(msalService, msalBroadcastService);
    this.agentAuthorizedApiEndpoints = this.appConfig.agentAuthorizedApi.map(api => {
      let [method, path] = api.split(" ");
      let regexPattern = path.replace(/\[.*?\]/i, '.*');
      return {
        api: path.toLowerCase(),
        method: method,
        regex: new RegExp(regexPattern, 'i')
      }
    })
  }

  skipApiEndPoint = this.appConfig.unauthorizedApi;

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler             
  ): Observable<HttpEvent<any>> {
    // To pass cookies value on every request which is going through the application.
    let isUnauthenticatedRequest = this.skipApiEndPoint.findIndex(x => request.url.toLowerCase().indexOf(x.toLowerCase()) >= 0) >= 0;

    if (isUnauthenticatedRequest) {
      const isAgentAuthorizedRequest = this.agentAuthorizedApiEndpoints.some(x =>
        (x.method === "ALL" || x.method.toLowerCase() === request.method.toLowerCase())
        && x.regex.test(request.url.toLowerCase()));

      isUnauthenticatedRequest = !isAgentAuthorizedRequest;
    }
    
    if (!isUnauthenticatedRequest) {
      request = request.clone({
        setHeaders: {
          env: "live",
          Authorization: `${this.tokenType} ${window.localStorage.getItem(this.token)}`,
        }
      });
    }


    if (isUnauthenticatedRequest) {

      return next.handle(request);
    }
    else {

      return super.intercept(request, next).pipe(
        tap(
          (event) => {
            if (event instanceof HttpResponse) {
            }
          },
          (error) => {
            if (error) {
              if (error.status) {
                if (error.status === 401) {
                  this._cookieService.deleteAll("/");
                  window.localStorage.removeItem("isAdmin");
                  window.localStorage.removeItem("agentProfileInfo");
                  this.appConfig.SharedComponent.userLoggedIn = false;
                  this.appConfig.SharedComponent.userName = null;
                  this.appConfig.SharedComponent.loggedInUserInfo = null;
                  this.appConfig.SharedComponent.notificationCount = 0;
                  this.appConfig.SharedComponent.inboxCount = 0;
                  this.chatService.SharedChatComponent.userActiveChat = [];
                  this.chatService.SharedChatComponent.userArchiveChat = [];
                  this.appConfig.SharedComponent.isWhatIsNewVisible = false;
                  this.signalRService.stopConnection();
                  if (
                    error.url &&
                    !error.url.includes("Tracking")
                  ) {
                    this._toaster.error("Please Login to access this page!");
                    this.router.navigateByUrl("/");
                  }
                }
              }
            }
          }
        )
      );
    }
  }
}